import React, { useContext, useEffect } from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import FormikArrayCheckbox from '../FormikArrayCheckbox';
import useSaleLocations from '../../../../../SaleLocations/hooks/useSaleLocations';
import { Context } from '../../../../../../../components/Store';

const SaleLocationsFilter = () => {
  const {
    isLoadingSaleLocationList,
    getSaleLocationList,
    saleLocationList
  } = useSaleLocations();
  const [{ organization }] = useContext(Context);

  useEffect(() => {
    getSaleLocationList(organization.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoadingSaleLocationList ? (
        <LoadingSpinner message="" label="Loading sale locations" />
      ) : (
        <>
          {saleLocationList?.length > 0 ? (
            saleLocationList?.map(saleLocation => (
              <div key={saleLocation?.id} className="flex items-center py-6px">
                <FormikArrayCheckbox name="saleIds" value={saleLocation.id}>
                  {saleLocation?.name}
                </FormikArrayCheckbox>
              </div>
            ))
          ) : (
            <div className="text-neutral-60 text-sm ">
              No sale locations found.
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SaleLocationsFilter;
